import styled from '@emotion/styled'
import { SKIP_DOLLAR_PROPS } from '@helpers/styles'
import { Box } from '@mui/material'

const Container = styled(Box, SKIP_DOLLAR_PROPS)<{
	$disabled?: boolean
	$selected?: boolean
}>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	width: 360px;
	height: 205px;
	padding: 30px;
	${({ $disabled, $selected, theme }) => `
       cursor: ${$disabled ? 'initial' : 'pointer'};
       opacity: ${$disabled ? '0.5' : '1'};
       border: 1px solid ${
					$selected
						? theme.palette.primary.main
						: theme.palette.borderColors.lightGrey
				};
       border-radius: ${theme.shape.borderRadius || '0'}px;
               ${
									!$disabled &&
									`&:hover { border: 1px solid ${theme.palette.primary.main}; }`
								}
    `}
`

const ContainerButton = styled.button`
	all: unset;
	pointer-events: none !important;
`

export { Container, ContainerButton }
